import { prefix } from './actions';

export const list = state => state[prefix].list;
export const item = state => state[prefix].item;
export const loading = state => state[prefix].loading;

export const listAdmin = state => state[prefix].listAdmin;
export const itemAdmin = state => state[prefix].itemAdmin;
export const saving = state => state[prefix].saving;
export const editModalOpened = state => state[prefix].editModalOpened;
